import React from 'react';

const UserPreferences = ({ userId, active, checkInPreference }) => {
  if (!active) return null;

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <h2 className="text-xl font-bold mb-6">User Preferences</h2>
      {checkInPreference ? (
        <div className="space-y-4">
          <div>
            <span className="font-semibold">Seat Position:</span>{' '}
            <span className="text-gray-700">{checkInPreference.seatPosition || 'Not set'}</span>
          </div>
          <div>
            <span className="font-semibold">Row Position:</span>{' '}
            <span className="text-gray-700">{checkInPreference.rowPosition || 'Not set'}</span>
          </div>
        </div>
      ) : (
        <div className="text-gray-500">No preferences found.</div>
      )}
    </div>
  );
};

export default UserPreferences; 